import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonCloudStudioModule, ENVIRONMENT } from 'common-cloudstudio';
import { SharedModule } from '../../shared/shared.module';
import { IncidentManagementComponent } from './incident-management.component';
import { IncidentFiltersComponent } from '../incident-filters/incident-filters.component';
import { IncidentFormModule } from '../incident-form/incident-form.module';
import { IncidentsComponent } from './incidents/incidents.component';
import { CommunicationsComponent } from './communications/communications.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { IncidentManagementModalComponent } from './incident-management-modal/incident-management-modal.component';
import { CommunicationComponent } from '../communication-form/communication.component';
import { AssociateIncidentsComponent } from './associate-incidents/associate-incidents.component';
// import { IncidentFileComponent } from '../incident-file/incident-file.component';
import { IncidentFileModule } from '../incident-file/incident-file.module';

declare var environment;

export function environmentFactory(): any {
  return environment;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    BsDropdownModule,
    SharedModule,
    IncidentFormModule,
    IncidentFileModule
  ],
  declarations: [
    IncidentManagementComponent, 
    IncidentManagementModalComponent,
    IncidentFiltersComponent, 
    IncidentsComponent, 
    CommunicationComponent,
    CommunicationsComponent,
    AssociateIncidentsComponent,
    // IncidentFileComponent
  ],
  exports: [IncidentManagementComponent],
  providers: [{ provide: ENVIRONMENT, useFactory: environmentFactory },],
})
export class IncidentManagementModule {}
